import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import GetApp from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const FileUpload = ({ upload, tooltip }) => {
  const inputFile = useRef(null);

  const onFileInputChange = (e) => {
    if (e?.target?.files[0]) {
      const formData = new FormData();
      formData.append('file', e?.target?.files[0]);
      upload(formData);
      e.target.value = null;
    }
  };

  return (
    <>
      <Tooltip title={tooltip} arrow>
        <IconButton
          size={'small'}
          onClick={() => {
            inputFile.current.click();
          }}>
          <GetApp fontSize={'large'} />
        </IconButton>
      </Tooltip>

      <input type={'file'} accept=".csv" ref={inputFile} onChange={onFileInputChange} style={{ display: 'none' }} />
    </>
  );
};

FileUpload.propTypes = {
  upload: PropTypes.func,
  tooltip: PropTypes.node,
};

export default FileUpload;
